import React from "react";
import { FormattedMessage } from "react-intl";
import css from "./Agenda.module.css";
export var MonographUnitLine = function (_a) {
    var _b, _c;
    var row = _a.row;
    return row.periodicalIssueId ? (React.createElement("span", { className: css.unitLine, "data-test-id": "monograph-unit-issue" },
        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.agenda.row.issue", values: { volume: (_b = row.volumeLabel) !== null && _b !== void 0 ? _b : "", issue: (_c = row.issueLabel) !== null && _c !== void 0 ? _c : "" } }))) : null;
};
